<template>
  <v-row justify="center">
    <v-dialog v-model='importfilemodal' max-width="500">
      <v-card>
        <v-toolbar height="73" color="white" class="headlinestyle">
          <v-btn icon @click="importfilemodal = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title><strong>{{title}}</strong></v-toolbar-title>
        </v-toolbar>
        <v-container>
          <v-layout row wrap justify-center>
            <v-flex xs10 sm8 md8 lg8>
              <v-file-input
                  label="Upload file"
                  prepend-icon="mdi-file"
                  v-model="files"
                  accept=".csv"
                  @change="onChangeFileUpload()"
                  color="pink lighten-2"
                ></v-file-input>
                <v-layout justify-center>
                  <!-- <v-img v-if="url" :src="url" class="grey lighten-2" max-width="250" max-height="250"  /> -->
                </v-layout>
            </v-flex>
          </v-layout>
        <v-layout row wrap justify-center>
          <v-flex xs0 sm1 md1 lg1 />
          <v-flex xs10 sm9 md9 lg9>
            <small>{{description}} หรือ <a v-on:click="downloadformat()"> ดาวน์โหลดตัวอย่าง</a></small>
          </v-flex>
        </v-layout>
        </v-container>
        <v-card-actions>
          <div class="flex-grow-1"></div>

          <v-btn color="pink" style="margin-right: 5px" outlined @click="importfilemodal = false">ยกเลิก</v-btn>

          <v-btn color="pink lighten-2" dark @click="save()">บันทึก</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="vld-parent">
      <loading :active.sync="isLoading" is-full-page></loading>
    </div>
  </v-row>
</template>

<script>
import { sync } from 'vuex-pathify'
// import CSVToJSON from 'csvtojson'
import swal from 'sweetalert'
import { Parser } from 'json2csv'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
export default {
  components: {
    Loading
  },
  data () {
    return {
      title: 'Import file CSV',
      description: '*เพื่อการทำงานที่ถูกต้องกรุณา Upload File CSV ที่มี Header ดังนี้ รหัสซื้อขาย, ชื่อสินค้า, ราคา, ประเภท',
      url: null,
      files: null,
      file: null,
      isLoading: false
    }
  },
  props: {
    // eslint-disable-next-line vue/require-prop-type-constructor
    productparentgetdata: '',
    // eslint-disable-next-line vue/require-prop-type-constructor
    userparentgetdata: ''
  },
  methods: {
    async save () {
      try {
        if (this.file) {
          let formdata = new FormData()
          formdata.append(`file`, this.file)
          this.isLoading = true
          if (this.importmodel === 2) {
            await this.axios.post(`${process.env.VUE_APP_API}/user/create/import`, formdata, {
              headers: {
                Authorization: this.$cookies.get('token')
              }
            })
            this.isLoading = await false
            this.importfilemodal = false
            await swal('บันทึกข้อมูลร้านค้าใหม่เรียบร้อย', {
              icon: 'success',
              buttons: 'ตกลง'
            })
            this.userparentgetdata()
          } else {
            await this.axios.post(`${process.env.VUE_APP_API}/product/add/import`, formdata, {
              headers: {
                Authorization: this.$cookies.get('token')
              }
            })
            this.isLoading = await false
            this.importfilemodal = false
            await swal('บันทึกข้อมูลสินค้าใหม่เรียบร้อย', {
              icon: 'success',
              buttons: 'ตกลง'
            })
            this.productparentgetdata()
          }
        } else {
          await swal({
            title: `กรุณาเลือกไฟล์ที่ต้องการ Import`,
            icon: 'warning',
            buttons: 'ตกลง',
            dangerMode: true
          })
        }
      } catch (error) {
        this.isLoading = await false
        await swal({
          title: `ระบบผิดพลาด`,
          text: 'กรุณาลองอีกครั้งในภายหลัง',
          icon: 'warning',
          buttons: 'ตกลง',
          dangerMode: true
        })
      }
    },
    onChangeFileUpload () {
      if (this.files !== null) {
        this.file = this.files
        this.url = URL.createObjectURL(this.file)
      } else {
        this.file = ''
        this.url = ''
      }
    },
    downloadformat () {
      let header = []
      let result = []
      let filename = ''
      if (this.importmodel === 2) {
        header = ['รหัสร้านค้า', 'password', 'ชื่อ-สกุล', 'เบอร์โทร', 'ที่อยู่', 'รหัสตารางสินค้า']
        result = [{
          'รหัสร้านค้า': '',
          'password': '',
          'ชื่อ-สกุล': '',
          'เบอร์โทร': '',
          'ที่อยู่': '',
          'รหัสตารางสินค้า': '',
          'เจ้าหน้าที่ผู้ดูแล': ''
        }]
        filename = `importuser.csv`
      } else {
        header = ['รหัสซื้อขาย', 'ชื่อสินค้า', 'ราคา', 'ประเภท']
        result = [{
          'รหัสซื้อขาย': '',
          'ชื่อสินค้า': '',
          'ราคา': '',
          'ประเภท': ''
        }]
        filename = `importproduct.csv`
      }
      const json2csvParser = new Parser({ quote: '' })
      const csv = json2csvParser.parse(result, { header })
      var downloadLink = document.createElement('a')
      var blob = new Blob(['\ufeff', csv])
      var url = URL.createObjectURL(blob)
      downloadLink.href = url
      downloadLink.download = filename
      document.body.appendChild(downloadLink)
      downloadLink.click()
      document.body.removeChild(downloadLink)
    }
  },
  computed: {
    importfilemodal: sync('importfilemodal'),
    importmodel: sync('importmodel')
  },
  watch: {
    importmodel () {
      if (this.importmodel === 2) {
        this.description = '*เพื่อการทำงานที่ถูกต้องกรุณา Upload File CSV ที่มี Header ดังนี้ รหัสร้านค้า, ชื่อ-สกุล,  password, ที่อยู่, เบอร์โทร, ที่อยู่, รหัสตารางสินค้า, เจ้าหน้าที่ผู้ดูแล'
      }
    }
  }
}
</script>
<style>
.headlinestyle {
  font-family: 'Kanit';
  font-style: normal;
  font-weight: normal;
  font-size: 30px;
  line-height: 54px;
  color: #000000;
}
p.label {
  font-family: 'Kanit';
  font-style: normal;
  font-weight: normal;
  color: #787878;
}
.inputstyle {
  font-family: 'Kanit';
  font-style: normal;
  font-weight: normal;
}
.v-text-field {
  font-family: 'Kanit';
}
.v-btn {
  font-family: 'Kanit';
  font-weight: bold;
}
.v-list-item__title {
  font-family: 'Kanit';
}
small {
  font-family: 'Kanit';
  color: tomato;
}
</style>
